<template>
  <div>
    <section>
       <v-row justify="center">
        <v-col cols="12">
          <v-card class="transparent elevation-0">
            <v-card-title class="display-1">
              <v-container container--fluid grid-list-lg>
                 <v-row align="center">
                   <h1>My Manifests</h1>
                  <v-spacer></v-spacer>
                     <v-tooltip top color="secondary">
                       <template v-slot:activator="{ on }">
                         <v-btn icon color="blue darken-1" to="/upload_manifest" v-on="on">
                           <v-icon>cloud_upload</v-icon>
                         </v-btn>
                       </template>
                       <span>Upload your manifest</span>
                     </v-tooltip>
                 </v-row>
                <v-row justify="space-between" :class="{'flex-column': $vuetify.breakpoint.smAndDown}" align="center">
                  <v-col md="4" sm="12">
                    <v-text-field
                      v-model="search"
                      label="Search..."
                      prepend-icon="fas fa-search"
                      clearable
                    >
                    </v-text-field>
                  </v-col>
                  <v-col md="4" sm="12">
                    <v-menu
                      v-model="menuStart"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateStart"
                          label="From ..."
                          prepend-icon="fas fa-calendar"
                          v-on="on"
                          readonly
                        >
                          <template v-slot:append>
                            <v-btn rounded small @click="dateStart=null" color="blue darken-1">Clear</v-btn>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="dateStart" @input="menuStart = false" style="width: 100%"></v-date-picker>
                    </v-menu>
                  </v-col>

                 </v-row>
              </v-container>
            </v-card-title>
            <v-divider color="#42a5f5"></v-divider>
            <transition name="slide-y-transition">
              <v-progress-linear v-if="loading" :indeterminate="loading"></v-progress-linear>
            </transition>
            <ManifestTable
              v-if="manifests"
              :manifests="manifests"
              :is-internal-user="isInternalUser"
              :search="search"
              v-on:alert="displayAlert"
            ></ManifestTable>
          </v-card>
        </v-col>
       </v-row>

      <v-dialog v-model="alertDialog" width="500px">
        <v-card>
          <v-card-title>
           <h3>ALERT</h3>
          </v-card-title>
          <v-divider color="#42a5f5"></v-divider>
          <v-card-text class="justify-center">{{alertMessage}}</v-card-text>
          <v-card-actions class="text-center">
            <v-btn text color="blue darken-1" @click="alertDialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>
  </div>
</template>

<script>
  import axios from 'axios'
  import ManifestTable from "../../util/Manifest/ManifestTable";

  // @vuese
  // Manifest Page where you can see the uploaded manifests, download the original CSVs or upload you manifest.
  // @group Manifest
  export default {
    name: "ManifestsPage",
    components: {ManifestTable},
    data() {
      return {
        alertDialog: false,
        alertMessage: null,
        dateStart: null,
        menuStart: false,
        search: '',
        loading: false,
      }

    },
    methods: {
      // @vuese
      // Displays an alertMessage passed as a string argument.
      displayAlert(message) {
        this.alertMessage = message;
        this.alertDialog = true
      },
    },
    computed: {
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      }
    },
    asyncComputed: {
      async manifests() {
        this.loading = true;
        let suffix = '';
        if (this.dateStart === null) {
          suffix = '/manifests'
        } else {
          suffix = '/manifests?from=' + this.dateStart;
        }
        let manifests = await axios.get(process.env.API_URL + suffix)
          .then((response) => {
            return response.data;
          })
          .catch((response) => {
            return [];
          });
        this.loading = false;
        return manifests;
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Manage/ManifestsPage.vue